// extracted by mini-css-extract-plugin
export default {"body":"Account_body__RSuYR","form":"Account_form__AxruC","detail":"Account_detail__Pm4Ju","action":"Account_action__k7Tha","google":"Account_google__nNBHN"};